/* eslint no-use-before-define: ["error", { "variables": false }] */

import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native-web';

export default class Send extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
  }

  handleOnPress = () => {
    const { text, onSend } = this.props;
    if (text && onSend) {
      onSend({ text: text.trim() }, true);
    }
  };

  render() {
    const { renderSendIcon, renderSendHoverIcon, text, renderSendLabel } = this.props;
    const { isHovered } = this.state;
    const isDisabled = this.props.disabled || !text || text.trim().length === 0;

    if (renderSendIcon) {
      return (
        <View style={[styles.container, this.props.containerStyle]}>
          <TouchableOpacity
            testID='send'
            accessible
            accessibilityLabel='send'
            style={[styles.touchable, isDisabled && styles.disabled]}
            onPress={this.handleOnPress}
            disabled={isDisabled}
            onMouseEnter={() => this.setState({ isHovered: true })}
            onMouseLeave={() => this.setState({ isHovered: false })}
          >
            <View style={[styles.wrapper, this.props.wrapperStyle, isDisabled && styles.wrapperDisabled]}>
              {isHovered && !isDisabled && renderSendHoverIcon ? renderSendHoverIcon() : renderSendIcon()}
            </View>
          </TouchableOpacity>
          {renderSendLabel && (
            <Text style={[styles.sendLabel, isDisabled && styles.sendLabelDisabled]}>{renderSendLabel}</Text>
          )}
        </View>
      );
    }
    return null;
  }
}

const styles = StyleSheet.create({
  container: {
    minHeight: 40,
    justifyContent: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: 10
  },
  touchable: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  disabled: {
    opacity: 0.5
  },
  wrapperDisabled: {
    opacity: 0.5
  },
  sendLabel: {
    fontSize: 9,
    color: 'var(--idigest-chat-fg, #000000)',
    marginTop: 2,
    textAlign: 'center',
    whiteSpace: 'nowrap'
  },
  sendLabelDisabled: {
    opacity: 0.5
  }
});

Send.defaultProps = {
  text: '',
  onSend: () => {},
  renderSendIcon: null,
  renderSendHoverIcon: null,
  renderSendLabel: null,
  disabled: false,
  containerStyle: {},
  wrapperStyle: {}
};

Send.propTypes = {
  text: PropTypes.string,
  onSend: PropTypes.func,
  renderSendIcon: PropTypes.func,
  renderSendHoverIcon: PropTypes.func,
  renderSendLabel: PropTypes.string,
  disabled: PropTypes.bool,
  containerStyle: PropTypes.object,
  wrapperStyle: PropTypes.object
};
